import styled from "styled-components";

export const InnerFormContainer = styled.div`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
`;
